import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FiUserCheck, FiUserPlus } from 'react-icons/fi';
import { cToggleFollow } from '../../api';
import { useCommunity } from '../../contexts/CommunityContext';
import { useLanguage } from '../../i18n';
import { NAVY, BLUE } from './brand';

/**
 * Follow / following / follow-back button.
 * `follows_you` (returned by the API) turns "Follow" into "Follow back".
 */
export default function FollowButton({ user, className = '', onChange, block = false }) {
  const { t } = useLanguage();
  const { user: me, requireAuth } = useCommunity();
  const [following, setFollowing] = useState(!!user?.is_following);
  const [followsYou] = useState(!!user?.follows_you);
  const [busy, setBusy] = useState(false);
  const [hover, setHover] = useState(false);

  if (!user || (me && me.id === user.id)) return null;

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!requireAuth(t('loginRequiredDesc'))) return;
    setBusy(true);
    try {
      const res = await cToggleFollow(user.id);
      setFollowing(res.following);
      if (onChange) onChange(res);
      toast.success(res.following ? `+1 ${t('followers')}` : '-1');
    } catch (err) {
      toast.error(err?.response?.data?.detail || t('somethingWrong'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-sfx="success"
      disabled={busy}
      onClick={toggle}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`inline-flex items-center justify-center gap-1.5 rounded-full font-bold transition disabled:opacity-60 ${
        block ? 'w-full px-4 py-2 text-sm' : 'px-3 py-1.5 text-xs'
      } ${following ? 'bg-white dark:bg-gray-900' : ''} ${className}`}
      style={following
        ? { color: NAVY, border: `1.5px solid ${NAVY}`, background: hover ? `${NAVY}14` : undefined }
        : { background: BLUE, color: '#fff', border: `1.5px solid ${BLUE}` }}
    >
      {following ? <FiUserCheck className="w-3.5 h-3.5" /> : <FiUserPlus className="w-3.5 h-3.5" />}
      {following ? t('following') : (followsYou ? t('followBack') : t('follow'))}
    </button>
  );
}
